import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Container } from "../../private/common/layout/styels";
import { useEffect, useState } from "react";
import withLayout from "../layout";
import { getData } from "../../../backend/api";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const LeftColumn = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 20px;
  max-width: 900px;
`;

const Heading = styled.h2`
  margin: 0 0 0.5rem 0;
  color: #222;
`;

const Heading2 = styled.h3`
  margin: 0;
  color: #0000aaff;
  text-transform: uppercase;
`;

const Paragraph = styled.p`
  margin: 0;
  line-height: 1.6;
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid #ddd;
  padding: 1rem 0;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-weight: 600;
  font-size: 1.1rem;
  color: #222;
  transition: color 0.3s ease;

  &:hover {
    color: #0000aaff;
  }
`;

const AccordionIcon = styled.span`
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? "rotate(180deg)" : "rotate(0deg)")};
`;

const AccordionContent = styled.div`
  max-height: ${({ open }) => (open ? "500px" : "0px")};
  overflow: hidden;
  transition: max-height 0.35s ease, opacity 0.3s ease, transform 0.3s ease;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transform: ${({ open }) => (open ? "translateY(0px)" : "translateY(-8px)")};

  p {
    margin-top: 1rem;
    line-height: 1.6;
    color: #444;
  }
`;

const RowData = styled.div`
  padding: 2rem 0;
  display: flex;
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FAQCategories = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: row;
    overflow-x: auto;
    padding: 0;
    gap: 5px;
  }
`;

const FaqCategory = styled.div`
  padding: 10px;
  background-color: #FFFFFF;
  border: 1px solid #3FC4FD;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

  &:hover {
    color: #3FC4FDff;
  }

  &.active {
    background-color: #3FC4FD;
    color: #FFFFFF;
  }
`;


const FAQ = ({ setLoaderBox }) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [faqs, setFaqs] = useState([]);
  const [faqCategory, setFaqCategory] = useState([]);

  const [activeCategory, setActiveCategory] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    fetchFaqCategories(); // NEW
    fetchFaq();
  }, []);

  // ⭐ NEW: Fetch FAQ categories
  const fetchFaqCategories = async () => {
    try {
      setLoaderBox(true);

      const response = await getData({}, "faq-category", dispatch, navigate);

      if (response.status === 200) {
        const data = response?.data?.data || [];
        setFaqCategory(data);

        if (data.length > 0) {
          setActiveCategory(data[0]._id); // Set first category as default
        }
      }
      setLoaderBox(false);
    } catch (error) {
      console.error("Error fetching FAQ categories:", error);
      setLoaderBox(false);
    }
  };

  // Fetch FAQs
  const fetchFaq = async () => {
    try {
      setLoaderBox(true);
      const response = await getData({}, "faq", dispatch, navigate);

      if (response.status === 200) {
        setFaqs(response?.data?.data || []);
      }

      setLoaderBox(false);
    } catch (error) {
      console.error(error);
      setLoaderBox(false);
    }
  };


  return (
    <Container className="noshadow column" style={{ padding: "0" }}>
      <LeftColumn>
        <Heading2>{t("HELP")}</Heading2>
        <Heading>{t("Frequently Asked Questions")}</Heading>
        <Paragraph>{t("Explore quick answers to common questions; we've got everything you need to know.")}</Paragraph>

        <RowData>

          {/* CATEGORIES */}
          <FAQCategories>
            {faqCategory?.map((category) => (
              <FaqCategory
                key={category._id}
                className={category._id === activeCategory ? "active" : ""}
                onClick={() => {
                  setActiveCategory(category._id);
                  setActiveIndex(-1);
                }}
              >
                {category[sessionStorage.getItem("_lang") ?? "de"]}
              </FaqCategory>
            ))}
          </FAQCategories>

          {/* FAQ LIST */}
          <Wrapper style={{ width: "100%" }}>
            {(faqs?.filter((item) => item.category._id === activeCategory).length > 0) ?
              faqs
                .filter((item) => item.category._id === activeCategory)
                .map((faq, index) => (
                  <AccordionItem key={faq._id}>
                    <AccordionHeader onClick={() => toggleFAQ(index)}>
                      {faq.question}
                      <AccordionIcon open={activeIndex === index}>▼</AccordionIcon>
                    </AccordionHeader>

                    <AccordionContent open={activeIndex === index}>
                      <p>{faq.answer}</p>
                    </AccordionContent>
                  </AccordionItem>
                ))
              :
              <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {t("There is no data available.")}
              </div>
            }
          </Wrapper>

        </RowData>
      </LeftColumn>
    </Container>
  );
};

export default withLayout(FAQ);
